
import * as storyblokRuntime$WlZg6gr1LybZkJTTEJplEKXFDdnsPODOFMMjJD2f0Jw from '/codebuild/output/src783351460/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as awsAmplifyRuntime$IXIB3cGsUiCsDO_KiZMygTJJZHfXbU3q2CpWh7NBp3w from '/codebuild/output/src783351460/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$WlZg6gr1LybZkJTTEJplEKXFDdnsPODOFMMjJD2f0Jw, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['awsAmplify']: { provider: awsAmplifyRuntime$IXIB3cGsUiCsDO_KiZMygTJJZHfXbU3q2CpWh7NBp3w, defaults: {} }
}
        